import React from "react";
import styled from "styled-components";
import { ReactComponent as QuestionIcon } from "../../assets/svg/question.svg";
import colours from "../../lib/colours";

const ButtonContainer = styled.button`
  width: 18px;
  height: 18px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 25px;
  padding: 0;
  cursor: pointer;
  transition: background-color 0.3s linear;
`;

const DefaultButtonContainer = styled(ButtonContainer)`
  top: -1px;
  background-color: ${colours.offWhite};
  &:hover {
    background-color: ${colours.th2l1}};
  }
  &:focus {
    outline: 5px auto ${colours.th1};
    background-color: ${colours.th2l1}};
  }
`;

interface IProps {
  onClick: any;
}

const HelpButton = ({ onClick }: IProps) => {
  return (
    <DefaultButtonContainer onClick={onClick}>
      <QuestionIcon style={{ height: "9px", width: "6.2px" }} />
    </DefaultButtonContainer>
  );
};

export default HelpButton;
